module.exports = __webpack_public_path__ + "img/mendi_logo.a16036cc.jpg";